module.exports = __webpack_public_path__ + "img/fu0005.f8564fdc.webp";